
var GoogleAddressField = function(options){

  this.options = {
    $addressField: false,
    fields: {
      $address: false,
      $city: false,
      $state: false,
      $zipcode: false,
      $country: false
    },
    callback: function(){}
  };

  // helps us with formatting results of google data
  this.componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'long_name',
    country: 'long_name',
    postal_code: 'short_name'
  };

  $.extend(true, this.options, options);

};

GoogleAddressField.prototype.init = function(){

  var self = this;

  google.maps.event.addDomListener(window, 'load', function(){
    self.initAutocomplete();
  });

  // gotta kill the enter to submit for the address field
  /*
  google.maps.event.addDomListener(this.options.fields.$address[0], 'keydown', function(event) {
    if (event.keyCode === 13) {
        event.preventDefault();
    }
  });
  */

  this.options.$addressField.focus(function() {
    self.geolocate();
  });

  this.initAutocomplete();

};

GoogleAddressField.prototype.initAutocomplete = function() {

  var self = this;

  console.log(self.options.$addressField[0]);

  // Create the autocomplete object, restricting the search to geographical location types.
  this.autocomplete = new google.maps.places.Autocomplete(self.options.$addressField[0],{types: ['geocode']});

  // When the user selects an address from the dropdown, populate the address fields in the form.

  this.autocomplete.addListener('place_changed', function(){
    self.fillInAddress();
  });


}

GoogleAddressField.prototype.fillInAddress = function() {

  var self = this;

  // Get the place details from the autocomplete object.
  var place = this.autocomplete.getPlace();

  // Get each component of the address from the place details
  // and fill the corresponding field on the form.

  if(typeof place === "undefined"){
    return;
  }

  for (var i = 0; i < place.address_components.length; i++) {
    var addressType = place.address_components[i].types[0];
    this.fillInAddressField(addressType, place.address_components[i][this.componentForm[addressType]]);
  }

  this.options.callback();

}

GoogleAddressField.prototype.fillInAddressField = function(addressType, value){

  switch (addressType) {

    case "street_number":
      this.options.fields.$address.val(value);
      this.options.fields.$address.closest('[data-form-field-text]').addClass('is-focused');
      break;
    case "route":
      var existingValue = this.options.fields.$address.val();
      this.options.fields.$address.val(existingValue + " " + value);
      this.options.fields.$address.closest('[data-form-field-text]').addClass('is-focused');
      break;
    case "neighborhood":
      // nothing
      break;
    case "locality":
      this.options.fields.$city.val(value);
      this.options.fields.$city.closest('[data-form-field-text]').addClass('is-focused');
      break;
    case "administrative_area_level_2":
      // nothing
      break;
    case "administrative_area_level_1":
      this.options.fields.$state.val(value);
      this.options.fields.$state.closest('[data-form-field-text]').addClass('is-focused');
      break;
    case "country":
      // nothing
      if (this.options.fields.$country) {
        this.options.fields.$country.val(value);
        this.options.fields.$country.closest('[data-form-field-text]').addClass('is-focused');
      }
      break;
    case "postal_code":
      this.options.fields.$zipcode.val(value);
      this.options.fields.$zipcode.closest('[data-form-field-text]').addClass('is-focused');
      break;

  }

};


//
// Not sure if this is working down here? It's not called from anywhere above...
//

// Bias the autocomplete object to the user's geographical location,
// as supplied by the browser's 'navigator.geolocation' object.
GoogleAddressField.prototype.geolocate = function() {

  var self = this;

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function(position) {
      var geolocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      var circle = new google.maps.Circle({
        center: geolocation,
        radius: position.coords.accuracy
      });
      self.autocomplete.setBounds(circle.getBounds());
    });
  }

}

export default GoogleAddressField;
